import { format } from "date-fns";

type DateInput = string | number | Date;

export const formatTime = (s: number) => {
  let timeString = "";
  let hours = Math.floor(s / 3600);
  let minutes = Math.floor((s - hours * 3600) / 60);
  let seconds = Math.floor(s - hours * 3600 - minutes * 60);

  timeString = hours ? timeString + hours + "h " : timeString;
  timeString = minutes ? timeString + minutes + "m " : timeString;
  timeString = seconds ? timeString + seconds + "s" : timeString;

  return timeString;
};

export const formatDigitalTime = (s: number) => {
  let hours: number | string = Math.floor(s / 3600);
  let minutes: number | string = Math.floor((s - (hours as number) * 3600) / 60);
  let seconds: number | string = Math.floor(s - (hours as number) * 3600 - (minutes as number) * 60);

  if (hours < 10) {
    hours = "0" + hours;
  }
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return hours + ":" + minutes + ":" + seconds;
};

export const formatShortTime = (s: number) => {
  let timeString = "";
  let hours = Math.floor(s / 3600);
  let minutes = Math.floor((s - hours * 3600) / 60);

  timeString = hours ? timeString + hours + "h " : timeString;
  timeString = minutes ? timeString + minutes + "m " : timeString;

  return timeString;
};

export const formatShortDate = (dateString: DateInput, options: Parameters<typeof format>[2] = {}) =>
  format(new Date(dateString), "dd/MM/yyyy", options);

export const formatISODateTime = (dateString: DateInput) =>
  format(new Date(dateString), "yyyy-MM-dd'T'HH:mm:ss")

export const formatShortMonthDate = (dateString: DateInput) =>
  format(new Date(dateString), "dd MMM yyyy");

  export const formatShortMonthDateAndTime = (dateString: DateInput) =>
    format(new Date(dateString), "dd MMM yyyy HH:mm");